<div class="measuringDeviceCard" [attr.uid]="'measuringDeviceCard__' + product().key + '__card'">
  <div
    class="measuringDeviceCard__container"
    [ngClass]="['measuringDeviceCard___' + product().key]"
  >
    <div class="measuringDeviceCard__topRight">
      @if (product().key === ProductKey.APPLE_WATCH) {
        <button
          class="infoButton"
          (click)="openInfoModal()"
          [attr.aria-label]="`Open info modal for ${product().ui.title}`"
        >
          <img alt="info" class="infoButton__img" src="/assets/img/icons/info-button.svg" />
        </button>
      }
      @if (showTag()) {
        <div
          class="tag"
          [class.tag___ab390Test]="ab390Bucket() === 'test'"
          [class.tag___ab390Test2]="ab390Bucket() === 'test2'"
        >
          <div class="tag__inner">
            @if (product().key === ProductKey.OURA_RING_DISCOUNT) {
              <span>{{ 'tag-off' | translate: { amount: ouraDiscountPercentage } }}</span>
            } @else if (product().key === ProductKey.B1) {
              <span>{{ 'tag-off' | translate: { amount: '50%' } }}</span>
            } @else if (isNcHardware()) {
              <span>{{ 'tag-free' | translate }}</span>
            }
          </div>
        </div>
      }
    </div>
    <div class="measuringDeviceCard__header">
      <h1 class="measuringDeviceCard__title">
        @if (product().ui.logo) {
          <img [src]="product().ui.logo" alt="" />
        }
        {{ product().ui.title }}
      </h1>
      <h3 class="measuringDeviceCard__subtitle">{{ productContent().description }}</h3>
    </div>
    <div class="measuringDeviceCard__bullets">
      @for (bullet of productContent().bulletPoints; track bullet) {
        <div class="measuringDeviceCard__bullet">
          <img
            class="measuringDeviceCard__bulletIcon"
            src="/assets/img/icons/dark-blue-check.svg"
            alt=""
          />
          <span [innerHTML]="bullet"></span>
        </div>
      }
    </div>
    <app-button
      [id]="'measuringDeviceCard__' + product().key + '__button'"
      color="purple"
      class="measuringDeviceCard__button"
      label="{{ 'txt-select' | translate }}"
      [mixpanelEvent]="'measuringDeviceCard__' + product().key + '__button'"
      (click)="selected(product().key)"
    />
  </div>
</div>
